export default "__VITE_ASSET__4e380b30__"